class CartDrawer extends DrawerFixed {
  constructor() {
    super();
    
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    // 监听购物车数量更新事件
    document.addEventListener('afterUpdateQuantity', () => {
      this.updatePromotionBar();
    });

    // MutationObserver for detecting dynamic content updates
    this.observeContentChanges();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    document.documentElement.classList.add('no-scroll');
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.updateProductRecommendation();
    super.open(triggeredBy);
    this.updateDrawerFooterPadding();
  }

  updateDrawerFooterPadding() {
    try {
      const footer = this.querySelector('.drawer__footer');
      if (footer) {
        const footerHeight = footer.offsetHeight;
        const computedStyle = window.getComputedStyle(footer);
        const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
        const totalHeight = footerHeight + marginBottom;
        this.style.setProperty('--drawer-bottom-padding', `${totalHeight}px`);
      }
    } catch (e) {
      // 静默处理，不影响购物车功能
    }
  }

  close(evt) {
    const currentFooterAction = this.querySelector('cart-drawer-footer-action.open');
    if(currentFooterAction) {
      currentFooterAction.closeActionContent();
    }
    if(!this.classList.contains('busy') || !evt.target.closest('cart-drawer-footer-action')) {
      super.close(evt);
      document.documentElement.classList.remove('no-scroll');
    }    
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  // Observes changes in the content of the drawer
  observeContentChanges() {
    const drawerContent = this.querySelector('.drawer__inner');
    const observer = new MutationObserver(() => {
      // Recalculate footer padding whenever content changes
      this.updateDrawerFooterPadding();
    });

    observer.observe(drawerContent, {
      childList: true, // Listen for added or removed child nodes
      subtree: true,  // Listen for changes in all descendants
    });
  }

  renderContents(parsedState) {
    console.log("CartDrawer renderContents - parsedState:", parsedState);
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if(sectionElement) {
        sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      this.updatePromotionBar();
    });
  }

  updatePromotionBar() {
    const promotionBar = document.querySelector('yg-promotion-bar');
    if (promotionBar && promotionBar.updateCartTotal) {
      // 获取购物车总价元素（尝试多个可能的选择器）
      const totalElement = this.querySelector('.totals__subtotal-value') 
                        || this.querySelector('.cart-drawer__total-price')
                        || this.querySelector('[data-cart-total]')
                        || document.querySelector('.cart-drawer__footer--subtotal .price');
      
      if (totalElement) {
        const totalText = totalElement.textContent || totalElement.innerText || totalElement.getAttribute('data-cart-total') || '0';
        promotionBar.updateCartTotal(totalText);
      } else {
        // 如果找不到总价元素，尝试从 cart 对象获取
        if (window.cart && window.cart.total_price) {
          const cartTotal = window.cart.total_price / 100; // Shopify 价格以分为单位
          promotionBar.updateCartTotal(cartTotal.toString());
        }
      }
    }
  }

  updateProductRecommendation() {
    this.productRecommendation = this.querySelector('cart-product-recommendations');
    if(this.productRecommendation) {
      const cartItemsWrapper = this.querySelector('.cart-drawer__items');
      cartItemsWrapper.classList.toggle('cart-drawer__items--large', cartItemsWrapper.querySelectorAll('.cart-item').length > 1);
      this.productRecommendation.update();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.cart-drawer__items'
      },
      {
        id: 'cart-drawer',
        selector: '.cart-drawer__footer--subtotal'
      },
      {
        id: 'cart-drawer',
        selector: '#yg-cart-promotion-wrapper'
      },
      {
        id: 'cart-drawer',
        selector: '.yg-drawer-count-wrapper'
      },
      {
        id: 'cart-drawer',
        selector: 'yg-cart-discount'
      },
      {
        id: 'cart-drawer',
        selector: '#yg-recommend-products-wrapper'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }
}

// 购物车抽屉专用的删除按钮
class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const line = this.dataset.index;

      // 显示 loading
      const lineItem = document.getElementById(`CartDrawer-Item-${line}`);
      const loadingOverlay = lineItem?.querySelector('.loading-overlay');
      if (loadingOverlay) loadingOverlay.classList.remove('hidden');

      // 获取 cart-drawer-items 并调用 updateQuantity
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      if (cartDrawerItems) {
        cartDrawerItems.enableLoading(line);

        // Use full sections for removal (includes recommendations)
        const uniqueSections = [...new Set(cartDrawerItems.getSectionsToRender().map(s => s.id))];

        const body = JSON.stringify({
          line: line,
          quantity: 0,
          sections: uniqueSections,
          sections_url: window.location.pathname
        });

        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
          .then(response => response.text())
          .then(state => {
            const parsedState = JSON.parse(state);
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            const errors = document.getElementById('CartDrawer-CartErrors');

            if (parsedState.errors) {
              if (errors) errors.classList.remove('hidden');
              return;
            }

            // 使用 CartDrawerItems 的 renderContents 更新
            cartDrawerItems.renderContents(parsedState, lineItem, 'remove');
            document.dispatchEvent(new CustomEvent('afterUpdateQuantity'));
            if (errors) errors.classList.add('hidden');
          })
          .catch(() => {
            const errors = document.getElementById('CartDrawer-CartErrors');
            if (errors) {
              errors.classList.remove('hidden');
              errors.querySelector('span').textContent = window.cartStrings.error;
            }
          })
          .finally(() => {
            // 隐藏 loading
            if (loadingOverlay) loadingOverlay.classList.add('hidden');
            cartDrawerItems.disableLoading();
          });
      }
    });
  }
}

customElements.define('cart-drawer', CartDrawer);
if (!customElements.get('cart-drawer-remove-button')) {
  customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);
}

class CartDrawerItems extends CartItems {
  constructor() {
    super();

    // Initialize scheduler state FIRST so other methods can reference it
    this.quantityScheduler = {
      pendingChange: null,
      activeRequest: null,
      confirmedQuantities: new Map(),
      desiredQuantities: new Map(),
      coalesceTimeout: null,
      activeRequestId: 0,
    };

    // Remove parent's debounced change listener (set up by CartItems constructor)
    this.removeEventListener('change', this.debouncedOnChange);

    // Set up our own immediate change listener for cart drawer quantity inputs
    this.addEventListener('change', (event) => {
      const target = event.target;
      if (target && target.classList && target.classList.contains('quantity__input')) {
        this.onQuantityChange(event);
      }
    });

    // Initialize quantity tracking from current DOM values
    try {
      this.initQuantityTracking();
    } catch (e) {
      console.warn('CartDrawerItems: initQuantityTracking failed', e);
    }
  }

  disconnectedCallback() {
    if (this.quantityScheduler && this.quantityScheduler.coalesceTimeout) {
      clearTimeout(this.quantityScheduler.coalesceTimeout);
    }
  }

  // Track confirmed quantity after server response
  setConfirmedQuantity(line, quantity) {
    this.quantityScheduler.confirmedQuantities.set(line, quantity);
  }

  getConfirmedQuantity(line) {
    return this.quantityScheduler.confirmedQuantities.get(line);
  }

  // Track desired quantity from user input
  setDesiredQuantity(line, quantity) {
    this.quantityScheduler.desiredQuantities.set(line, quantity);
  }

  getDesiredQuantity(line) {
    return this.quantityScheduler.desiredQuantities.get(line);
  }

  // Initialize quantity tracking from DOM
  initQuantityTracking() {
    const inputs = this.querySelectorAll('.quantity__input');
    inputs.forEach(input => {
      const line = input.dataset.index;
      const quantity = parseInt(input.value) || 0;
      this.setConfirmedQuantity(line, quantity);
      this.setDesiredQuantity(line, quantity);
    });
  }

  // Immediate change handler for quantity inputs
  onQuantityChange(event) {
    const target = event.target;
    if (!target || !target.classList || !target.classList.contains('quantity__input')) {
      return;
    }

    const line = target.dataset.index;
    const quantity = target.value;
    const name = target.getAttribute('name') || 'updates[]';

    if (!line) {
      console.warn('CartDrawerItems: missing data-index on quantity input');
      return;
    }

    this.scheduleQuantityUpdate(line, quantity, name);
  }

  // Coalescing scheduler: 100ms window
  scheduleQuantityUpdate(line, quantity, name) {
    const scheduler = this.quantityScheduler;
    if (!scheduler) {
      console.warn('CartDrawerItems: scheduler not initialized');
      return;
    }

    const parsedQty = parseInt(quantity, 10);

    // Update desired quantity immediately for UI consistency
    this.setDesiredQuantity(line, isNaN(parsedQty) ? 0 : parsedQty);

    // Update input value immediately for instant UI feedback
    const input = this.querySelector(`#Drawer-quantity-${line}`);
    if (input) {
      input.value = quantity;
    }

    // Clear any pending change within coalescing window
    if (scheduler.coalesceTimeout) {
      clearTimeout(scheduler.coalesceTimeout);
    }

    // Store the latest desired change
    scheduler.pendingChange = {
      line,
      quantity: isNaN(parsedQty) ? 0 : parsedQty,
      name: name || 'updates[]',
      timestamp: Date.now()
    };

    // Set coalescing window to 100ms
    scheduler.coalesceTimeout = setTimeout(() => {
      this.flushPendingChange();
    }, 100);
  }

  // Flush the pending change (or skip if newer desired exists)
  flushPendingChange() {
    const scheduler = this.quantityScheduler;
    if (!scheduler || !scheduler.pendingChange) return;

    const pending = scheduler.pendingChange;
    scheduler.pendingChange = null;

    // If there's an active request, queue this change for later
    if (scheduler.activeRequest) {
      // Update desired quantity, will be sent after active request settles
      this.setDesiredQuantity(pending.line, pending.quantity);
      // Keep the pending change so it fires when active request settles
      scheduler.pendingChange = pending;
      return;
    }

    // No active request, send immediately
    this.sendQuantityUpdate(pending.line, pending.quantity, pending.name);
  }

  // Send quantity update with ordering protection
  sendQuantityUpdate(line, quantity, name) {
    const scheduler = this.quantityScheduler;
    if (!scheduler) return;

    const requestId = ++scheduler.activeRequestId;

    scheduler.activeRequest = {
      requestId,
      line,
      quantity,
      name
    };

    this.enableLoading(line);

    // Build unique section IDs array (deduplicated)
    const sectionsToRender = this.getSectionsToRenderQuantityOnly();
    const uniqueSections = [...new Set(sectionsToRender.map(s => s.id))];

    const body = JSON.stringify({
      line,
      quantity,
      sections: uniqueSections,
      sections_url: window.location.pathname
    });

    const errors = document.getElementById('CartDrawer-CartErrors');

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => response.text())
      .then((state) => {
        // Check if this response is still relevant (not superseded by newer request)
        if (!scheduler.activeRequest || scheduler.activeRequest.requestId !== requestId) {
          // A newer request has started, ignore this response
          return;
        }

        let parsedState;
        try {
          parsedState = JSON.parse(state);
        } catch (e) {
          console.error('CartDrawerItems: failed to parse response', e);
          this.finalizeRequest(requestId);
          return;
        }

        const quantityElement = document.getElementById(`Drawer-quantity-${line}`);

        if (parsedState.errors) {
          // Validation error - restore to server-confirmed quantity
          const confirmedQty = this.getConfirmedQuantity(line) || 0;
          if (quantityElement) quantityElement.value = confirmedQty;
          this.updateLiveRegions(line, parsedState.errors);
          this.finalizeRequest(requestId);
          return;
        }

        // Update confirmed quantity
        const updatedItem = parsedState.items && parsedState.items[line - 1];
        const serverQuantity = updatedItem ? updatedItem.quantity : undefined;
        this.setConfirmedQuantity(line, serverQuantity);

        // Check if desired quantity differs from server
        const desiredQty = this.getDesiredQuantity(line);
        if (desiredQty !== serverQuantity) {
          // Server quantity differs, update input and queue another request
          if (quantityElement) quantityElement.value = serverQuantity;
          this.finalizeRequest(requestId);
          // Schedule the desired quantity
          if (serverQuantity !== undefined) {
            setTimeout(() => {
              this.scheduleQuantityUpdate(line, desiredQty, name);
            }, 0);
          }
          return;
        }

        // Server quantity matches desired, render normally
        const items = document.querySelectorAll('.cart-item');
        let message = '';
        if (items.length === parsedState.items.length && serverQuantity !== parseInt(quantity)) {
          message = window.cartStrings.quantityError.replace('[quantity]', serverQuantity);
        }
        this.updateLiveRegions(line, message);

        this.renderContentsQuantityOnly(parsedState, line, name);
        if (errors) errors.classList.add('hidden');
        this.finalizeRequest(requestId);

        // Check if there's a pending change to send
        const pending = scheduler.pendingChange;
        if (pending && pending.line === line) {
          scheduler.pendingChange = null;
          this.scheduleQuantityUpdate(pending.line, pending.quantity, pending.name);
        } else if (pending) {
          // Different line - flush it
          this.flushPendingChange();
        }
      })
      .catch(() => {
        if (!scheduler.activeRequest || scheduler.activeRequest.requestId !== requestId) return;

        const errors = document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          errors.classList.remove('hidden');
          errors.querySelector('span').textContent = window.cartStrings.error;
        }
        this.finalizeRequest(requestId);
      })
      .finally(() => {
        if (!scheduler.activeRequest || scheduler.activeRequest.requestId !== requestId) return;
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
      });
  }

  // Finalize request and clear active state
  finalizeRequest(requestId) {
    const scheduler = this.quantityScheduler;
    if (scheduler.activeRequest?.requestId === requestId) {
      scheduler.activeRequest = null;
    }
  }

  // Get sections for quantity-only updates (unique IDs, no recommendations)
  getSectionsToRenderQuantityOnly() {
    return [
      { section: 'cart-drawer', id: 'cart-drawer', selector: '.cart-drawer__items' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: '.cart-drawer__footer--subtotal' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: '#yg-cart-promotion-wrapper' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: '.yg-drawer-count-wrapper' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: 'yg-cart-discount' },
      { section: 'cart-icon-bubble', id: 'cart-icon-bubble', selector: '.cart-count-bubble' },
    ];
  }

  // Override getSectionsToRender for full updates (removal, add-to-cart)
  getSectionsToRender() {
    return [
      { section: 'cart-drawer', id: 'cart-drawer', selector: '.cart-drawer__items' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: '.cart-drawer__footer--subtotal' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: '#yg-cart-promotion-wrapper' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: '.yg-drawer-count-wrapper' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: 'yg-cart-discount' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: '#yg-recommend-products-wrapper' },
      { section: 'cart-icon-bubble', id: 'cart-icon-bubble', selector: '.cart-count-bubble' },
    ];
  }

  // Optimized render for quantity-only updates - parses each section once
  renderContentsQuantityOnly(parsedState, line, name) {
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    if (cartDrawerWrapper) {
      cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    // Parse each unique section once and cache
    const sectionCache = new Map();

    this.getSectionsToRenderQuantityOnly().forEach((section => {
      // Check if we've already parsed this section ID
      if (!sectionCache.has(section.id)) {
        if (parsedState.sections && parsedState.sections[section.id]) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(parsedState.sections[section.id], 'text/html');
          sectionCache.set(section.id, {
            doc,
            selectors: {}
          });
        }
      }

      const cached = sectionCache.get(section.id);
      const sectionElement = document.querySelector(section.selector);

      if (sectionElement && cached) {
        // Reuse parsed document, just query different selector
        if (!cached.selectors[section.selector]) {
          cached.selectors[section.selector] = cached.doc.querySelector(section.selector)?.innerHTML || '';
        }
        sectionElement.innerHTML = cached.selectors[section.selector];
      }
    }));

    // Focus management
    const lineItem = document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem && name && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      const emptyContent = cartDrawerWrapper.querySelector('.drawer__inner-empty');
      const emptyLink = cartDrawerWrapper.querySelector('.drawer__inner-empty a');
      if (emptyContent && emptyLink) {
        trapFocus(cartDrawerWrapper, emptyLink);
      }
    }

    // DO NOT update product recommendations for quantity-only updates
    // They are only updated on removal or add-to-cart
  }

  // Override renderContents for full updates (removal, add-to-cart)
  renderContents(parsedState, lineItem, name) {
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    if (cartDrawerWrapper) {
      cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    // Parse each unique section once and cache
    const sectionCache = new Map();

    this.getSectionsToRender().forEach((section => {
      // Check if we've already parsed this section ID
      if (!sectionCache.has(section.id)) {
        if (parsedState.sections && parsedState.sections[section.id]) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(parsedState.sections[section.id], 'text/html');
          sectionCache.set(section.id, {
            doc,
            selectors: {}
          });
        }
      }

      const cached = sectionCache.get(section.id);
      const sectionElement = document.querySelector(section.selector);

      if (sectionElement && cached) {
        // Reuse parsed document, just query different selector
        if (!cached.selectors[section.selector]) {
          cached.selectors[section.selector] = cached.doc.querySelector(section.selector)?.innerHTML || '';
        }
        sectionElement.innerHTML = cached.selectors[section.selector];
      }
    }));

    if (lineItem && name && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      const emptyContent = cartDrawerWrapper.querySelector('.drawer__inner-empty');
      const emptyLink = cartDrawerWrapper.querySelector('.drawer__inner-empty a');
      if (emptyContent && emptyLink) {
        trapFocus(cartDrawerWrapper, emptyLink);
      }
    } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
      const firstItemName = cartDrawerWrapper.querySelector('.cart-item__name');
      if (firstItemName) {
        trapFocus(cartDrawerWrapper, firstItemName);
      }
    }

    // Update product recommendations for full updates (removal, add-to-cart)
    this.updateProductRecommendation();

    // Re-initialize quantity tracking
    this.initQuantityTracking();
  }

  updateProductRecommendation() {
    const recommendation = this.querySelector('cart-product-recommendations');
    if(recommendation) {
      recommendation.update();
    }
  }

  // Handle removal - uses parent's full update behavior
  onRemoveItem(line) {
    this.updateQuantity(line, 0, 'remove');
  }

  getSectionsToRenderForRemoval() {
    return this.getSectionsToRender();
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}

// 初始化购物车抽屉中的自定义元素
function initCartDrawerElements(container) {
  if (!container) container = document;
  
  // 初始化删除按钮
  container.querySelectorAll('cart-drawer-remove-button:not([initialized])').forEach(el => {
    el.setAttribute('initialized', '');
  });
}

// 监听购物车抽屉的 renderContents
const originalRenderContents = CartDrawer.prototype.renderContents;
CartDrawer.prototype.renderContents = function(parsedState) {
  originalRenderContents.call(this, parsedState);
  
  // 在内容更新后重新初始化自定义元素
  setTimeout(() => {
    initCartDrawerElements(this);
  }, 0);
};
